import type { PluginConfiguration } from './helpers'

type Configuration = { plugins: PluginConfiguration[]; apiUrl: string }

const configuration: Configuration = {
  plugins: [],
  apiUrl: '',
}

const updateConfiguration = (newConfiguration: Configuration) => {
  const uniquePlugins = new Map<string, PluginConfiguration>()

  const addPlugins = (plugins: PluginConfiguration[]) => {
    for (const plugin of plugins) {
      if (uniquePlugins.has(plugin.id)) {
        console.warn(`[FuTools]: Duplicate plugin id '${plugin.id}'`)
      } else {
        uniquePlugins.set(plugin.id, plugin)
      }
    }
  }

  addPlugins(configuration.plugins)
  addPlugins(newConfiguration.plugins)

  configuration.plugins = Array.from(uniquePlugins.values())
  configuration.apiUrl = newConfiguration.apiUrl
}

export { configuration, updateConfiguration }
